export default __webpack_public_path__ + "static/media/icon_survey_dissatisfied.3fe13f4e.svg";